var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mb-4",attrs:{"outlined":""}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t("monthly summaries"))+" "+_vm._s(_vm.rack)+" ")]),_vm._l((_vm.pdus),function(pdu,idx){return _c('power-summary-chart',{key:idx,attrs:{"pdu":pdu}})})],2),_c('power-details-chart',{attrs:{"rack":_vm.rack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }